export default __webpack_public_path__ + "static/media/Axe_2.1519b6ba.png";